import {
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@fluentui/react-components";
import { useMfaInitial } from "./mfaInitial/useMfaInitial";
import { translate } from "@/config/translator";
import PspButton from "@/components/pspButton/PspButton";

type MfaInitialProps = {
  onNext: () => void;
  onBack: () => void;
};

export function MfaInitial({ onBack, onNext }: MfaInitialProps) {
  const { lang } = useMfaInitial();
  return (
    <>
      <DialogTitle>{translate("setup2FaInitialTitle", lang)}</DialogTitle>
      <DialogContent className="text-font-secondary">
        {translate("setup2FaInitialBody", lang)}
      </DialogContent>
      <DialogActions>
        <PspButton appearance="secondary" onClick={onBack}>
          {translate("maybeLater", lang)}
        </PspButton>
        <PspButton appearance="primary" onClick={onNext}>
          {translate("continue", lang)}
        </PspButton>
      </DialogActions>
    </>
  );
}
